import React from 'react';
import { ProfilingResults } from './ProfilingResults';
import { DQResult } from '../Domain/DQResult';
import heartLoading from '../../../assests/heartLoading.gif';
import { ProfilingResultView } from '../Domain/ProfilingResult';

// Extracted Loader component
const Loader = ({ text }) => (

  <div className="flex items-center justify-center h-[300px]">
    <div className="flex flex-col items-center space-y-3">
      <img src={heartLoading} alt="Loading..." style={{ width : 200}} />
      <span className="text-gray-700 text-[20px] text-center">
        {text}                </span>
    </div>
  </div>
);

// Empty state component
const EmptyState = ({ message }) => (
  <div className="text-center py-8">
    <p className="text-gray-600">{message}</p>
  </div>
);

// Remediation placeholder component
const RemediationPlaceholder = () => (
  <div className="text-center py-8">
    <div className="max-w-md mx-auto">
      <div className="mb-4">
        <svg
          className="mx-auto h-16 w-16 text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
          />
        </svg>
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-2">
        Remediation Action
      </h3>
      <p className="text-gray-600 mb-4">
        This feature is currently under development and will be available soon.
      </p>
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <p className="text-sm text-blue-800">
          <strong>Coming Soon:</strong> Automated remediation actions for data quality issues,
          including rule suggestions and workflow automation.
        </p>
      </div>
    </div>
  </div>
);

const ResultsContent = ({
  activeResultTab,
  setActiveResultTab,
  profilingLoading,
  profilingResults,
  dqLoading,
  dqResults,
  showTabs = true,
}) => {
  // Tab content mapping - cleaner and more maintainable

  const getTabContent = () => {
  switch (activeResultTab) {
    case "profile":
      return profilingLoading ? (
        <Loader text="Loading profiling results..." />
      ) : profilingResults ? (
        <ProfilingResultView results={profilingResults?.profiling_results?.[0]?.columns || []} />
      ) : (
        <EmptyState message="No profiling results available" />
      );

    case "quality":
      return dqLoading ? (
        <Loader text="Loading data quality results..." />
      ) : dqResults ? (
        <DQResult results={dqResults} />
      ) : (
        <EmptyState message="No data quality results available" />
      );

    case "remediation":
      return <RemediationPlaceholder />;

    default:
      return <EmptyState message="No results available" />;
  }
};

  return (
    <>
      {/* Tabs - Only show if showTabs is true */}
      {showTabs && (
        <div className="border-b border-gray-200 mb-2">
          <div className="flex">
            <button
              onClick={() => setActiveResultTab("profile")}
              className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors ${activeResultTab === "profile"
                  ? "border-[#bb1ccc] text-[#bb1ccc]"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
            >
              Data Profile Results
            </button>
            <button
              onClick={() => setActiveResultTab("quality")}
              className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors ${activeResultTab === "quality"
                  ? "border-[#bb1ccc] text-[#bb1ccc]"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
            >
              Data Quality Results
            </button>
            <button
              disabled={true}
              className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors cursor-not-allowed opacity-50 ${activeResultTab === "remediation"
                  ? "border-[#bb1ccc] text-[#bb1ccc]"
                  : "border-transparent text-gray-400"
                }`}
              title="Remediation Action feature is currently disabled"
            >
              Remediation Action
            </button>
          </div>
        </div>
      )}

      {/* Content */}
      <div className={showTabs ? "p-6" : ""}>
        {getTabContent()}
      </div>
    </>
  );
};

export default ResultsContent;